/* Shirts Frenzy — collection AJAX filtering (collection-performance Phase 3b).
   Intercepts filter-rail / sort / pagination interactions on the collection page,
   fetches ONLY the sf-collection section via the Section Rendering API
   (?sections=sf-collection), and swaps it in — no full reload, so we don't re-ship
   the ~600 KB of Shopify analytics + header/footer chrome each filter change, and
   there's no white-flash navigation. ONE request per user action (bot-safe).

   Only links that carry a style filter are intercepted, so the fetched section can
   never be the no-style "Loading…" bail (the body gate / early-head redirect).
   Clear-all and "All Drops" (no style) fall through to a normal navigation. */
(function () {
  if (window.__sfCollAjax) return;
  window.__sfCollAjax = true;

  var STYLE_PARAM = 'filter.p.m.custom.style';
  var ctrl = null; // in-flight fetch, aborted when a newer action supersedes it

  function root() { return document.querySelector('.sf-skin.screen.catalog'); }
  // The bare section TYPE ('sf-collection') renders with SCHEMA DEFAULTS, not
  // the template's settings — that served 18/page after an AJAX collection
  // switch while full loads served the template's 12. Render the template's
  // section INSTANCE instead: its id lives on the wrapper around the grid
  // (shopify-section-template--<theme-specific>__sf_collection), read at call
  // time so it's correct on any theme (dev / preview / live), no hardcoding.
  function sectionKey() {
    var el = root();
    var wrap = el && el.closest('[id^="shopify-section-"]');
    return wrap ? wrap.id.replace(/^shopify-section-/, '') : TYPE_KEY;
  }
  // The section TYPE renders with SCHEMA defaults — deliberately set to 6/page
  // (vs the instance's 12) so it doubles as a fast preview render. See the
  // header comment in sections/sf-collection.liquid before "fixing" this.
  var TYPE_KEY = 'sf-collection';
  function withSections(url, key) { return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'sections=' + encodeURIComponent(key); }
  // Loading state = grid dim (existing) + a viewport-top progress runner. The
  // runner is the instant "your click registered" signal — shoppers were
  // double-clicking filters because nothing visible happened until the swap.
  // It lives INSIDE the catalog root so it inherits the accent custom props;
  // position:fixed keeps it viewport-anchored (and the swap's innerHTML replace
  // clears it automatically — setLoading(false) is just belt-and-braces).
  // Dim and bar are controlled separately: after the 6-card PREVIEW swap the dim
  // comes off (real content is showing) but the bar stays until the full render
  // lands. The swap's innerHTML replace destroys an in-grid bar, so setBar(true)
  // also re-appends after a swap.
  function setDim(on) { var r = root(); if (r) r.classList.toggle('sf-ajax-loading', on); }
  function setBar(on) {
    var bar = document.getElementById('sf-ajax-progress');
    if (on) {
      if (bar) return;
      var r = root(); if (!r) return;
      bar = document.createElement('div');
      bar.id = 'sf-ajax-progress';
      bar.className = 'sf-ajax-progress';
      r.appendChild(bar);
    } else if (bar) { bar.remove(); }
  }
  function setLoading(on) { setDim(on); setBar(on); }
  // Instant acknowledgment for the single-select rail lists (Collection + Style):
  // move the active state to the clicked item NOW, before the fetch. If the fetch
  // fails we fall back to a full navigation, which re-renders the true state.
  function markActive(a) {
    if (!a.classList.contains('fradio-item')) return;
    var list = a.closest('.fradio');
    if (!list) return;
    list.querySelectorAll('.fradio-item.on').forEach(function (x) { x.classList.remove('on'); });
    a.classList.add('on');
  }

  function reinit(scope) {
    var s = scope || document;
    // re-bind cards (idempotent via dataset.sfCar) + re-run the colour-facet split
    try { if (window.sfCards) { window.sfCards.facetInit(); window.sfCards.init(s); } } catch (e) {}
    // CRITICAL: the scroll-reveal observer (sf-reveal.js) only watches the ORIGINAL
    // cards, so swapped-in cards keep `.reveal` (opacity:0) forever — present + clickable
    // but invisible. Reveal them immediately (instant is the right feel for a filter change).
    try { s.querySelectorAll('.reveal:not(.in)').forEach(function (el) { el.classList.add('in'); }); } catch (e) {}
  }

  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.sf-skin.screen.catalog');
    var cur = root();
    if (!fresh || !cur) return false;
    // the fetched section MUST carry a real grid or the empty-state — never swap in
    // a bail/blank section (belt-and-braces against landing on a "Loading…" page)
    if (!fresh.querySelector('.grid-3') && !fresh.querySelector('.cat-empty')) return false;
    // innerHTML swap: the MOST cross-browser-robust update — re-parses the markup in
    // THIS document, so there's no cross-document node move (importNode/replaceWith,
    // which rendered blank in some browsers). cur stays put; only its children change.
    var st = fresh.getAttribute('style');
    if (st != null) cur.setAttribute('style', st);
    var missions = cur.querySelector('#sf-missions');
    var missionsOpen = missions && missions.open;
    // Replacing an open mobile filter drawer must release its page scroll lock.
    if (cur.querySelector('#sf-side.open')) document.body.style.overflow = '';
    cur.innerHTML = fresh.innerHTML;
    missions = cur.querySelector('#sf-missions');
    if (missions && missionsOpen) missions.open = true;
    reinit(cur);
    // post-swap sanity: if the grid somehow ended up empty, bail to a full load
    if (!cur.querySelector('.grid-3') && !cur.querySelector('.cat-empty')) return false;
    return true;
  }

  function fetchSection(url, key, signal) {
    return fetch(withSections(url, key), {
      signal: signal,
      headers: { 'X-Requested-With': 'fetch' },
      credentials: 'same-origin'
    })
      .then(function (r) { if (!r.ok) throw new Error('bad status'); return r.json(); })
      .then(function (j) { return j && (j[key] || j[TYPE_KEY]); });
  }

  function go(url, push, instantScroll) {
    if (ctrl) { ctrl.abort(); }                          // aborts BOTH in-flight renders
    ctrl = ('AbortController' in window) ? new AbortController() : null;
    var signal = ctrl && ctrl.signal;
    setLoading(true);
    var key = sectionKey();   // capture BEFORE the swap replaces the grid
    var pushed = false, finished = false, previewed = false;
    // update the URL BEFORE the first swap: the card JS reads activeFilterColor()
    // from location during re-init, so the colour/filter must already be in the URL
    // or set cards repaint to their default colour instead of the one just picked.
    function pushOnce() { if (push && !pushed) { pushed = true; try { history.pushState({ sfColl: 1 }, '', url); } catch (e) {} } }
    // bring results into view if the shopper had scrolled past the top of the grid.
    // Filter clicks glide (behavior:smooth — a gentle nudge mid-page); pagination
    // jumps instantly like a real page load (the click is at the BOTTOM of the grid,
    // so a smooth scroll there is a long animated ride nobody expects).
    function scrollGrid() {
      var r = root();
      if (r) {
        var top = r.getBoundingClientRect().top + window.pageYOffset - 70;
        if (window.pageYOffset > top + 1) window.scrollTo({ top: top, behavior: instantScroll ? 'auto' : 'smooth' });
      }
    }

    // Two-stage load: the section TYPE render (schema defaults = 6/page) is a light
    // request that usually lands well before the full 12-card instance render — swap
    // it in as soon as it arrives so the shopper sees fresh products immediately, then
    // the instance render replaces it. Best-effort: any preview failure is ignored and
    // the instance render below stays authoritative. Skipped on ?page= URLs — 6/page
    // pagination slices pages differently, so a preview there would show the WRONG six.
    var canPreview = key !== TYPE_KEY && !/[?&]page=/.test(url);
    if (canPreview) {
      fetchSection(url, TYPE_KEY, signal)
        .then(function (html) {
          if (finished || !html) return;                 // full render already landed
          pushOnce();
          var ok = false;
          try { ok = !!swap(html); } catch (e) { ok = false; }
          if (!ok || finished) return;
          previewed = true;
          // preview's pagination is 6/page (wrong page count) — hide it until the
          // full render; content is showing so drop the dim, keep the runner going.
          var r = root();
          var pg = r && r.querySelector('.sf-pagination');
          if (pg) pg.style.display = 'none';
          setDim(false);
          setBar(true);                                  // re-append (swap wiped it)
          scrollGrid();
        })
        .catch(function () { /* preview is best-effort */ });
    }

    fetchSection(url, key, signal)
      .then(function (html) {
        finished = true;
        pushOnce();
        var ok = false;
        try { ok = !!(html && swap(html)); } catch (e) { ok = false; }
        if (!ok) { window.location.reload(); return; }   // URL already == target → reload renders it; never blank
        setLoading(false);
        if (!previewed) scrollGrid();
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;        // superseded by a newer action
        finished = true;
        setLoading(false);
        window.location.href = url;                       // hard fallback to a normal load
      });
  }

  // exposed so the colour single-select handler (sf-cards.js) routes through AJAX
  window.sfAjaxNavigate = function (url) { go(url, true); };

  function plainLeftClick(e) {
    return !(e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey);
  }

  // ---- filter-rail + pagination links ----
  document.addEventListener('click', function (e) {
    if (!plainLeftClick(e)) return;
    var a = e.target.closest('a[href]');
    if (!a) return;
    if (a.hasAttribute('data-sf-color')) return;          // colour → sf-cards.js → sfAjaxNavigate
    if (a.classList.contains('fclear')) return;           // clear-all strips style → normal nav
    if (!a.closest('.cat-side') && !a.closest('.sf-pagination')) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf('/collections/') === -1) return;     // same-site collection links only
    if (href.indexOf(STYLE_PARAM) === -1) return;         // must keep a style → section can't bail to "Loading…"
    e.preventDefault();
    markActive(a);
    go(href, true, !!a.closest('.sf-pagination'));   // page links jump to top; filters glide
  });

  // ---- sort dropdown ----
  document.addEventListener('change', function (e) {
    if (!e.target.matches('#sf-sort')) return;
    var u = new URL(location.href);
    u.searchParams.set('sort_by', e.target.value);
    u.searchParams.delete('page');
    go(u.pathname + u.search, true);
  });

  // ---- mobile filter drawer (re-query fresh so it survives section swaps) ----
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-sf-side-open]');
    var close = e.target.closest('[data-sf-side-close]');
    if (!open && !close) return;
    e.preventDefault();
    var side = document.getElementById('sf-side');
    if (side) { side.classList.toggle('open', !!open); document.body.style.overflow = open ? 'hidden' : ''; }
  });

  // ---- price-range form: keep current URL params, add the price range ----
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#sf-filter-form');
    if (!form) return;
    e.preventDefault();
    var u = new URL(location.href);
    new FormData(form).forEach(function (val, key) {
      if (val === '' || val == null) u.searchParams.delete(key);
      else u.searchParams.set(key, val);
    });
    u.searchParams.delete('page');
    go(u.pathname + u.search, true);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('#sf-filter-form input[type="number"]')) {
      e.preventDefault();
      var f = e.target.closest('#sf-filter-form');
      if (f) { f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
    }
  });

  // ---- back / forward ----
  window.addEventListener('popstate', function () { go(location.pathname + location.search, false); });
})();
